import type { RefObject } from 'react';
import { useEffect, useState } from 'react';

export const useIsOverflowing = (
  containerRef: RefObject<HTMLDivElement | null>
) => {
  const [, updateState] = useState<unknown>();
  const [isOverflowing, setIsOverflowing] = useState(false);

  const handleResize = () => {
    if (containerRef.current) {
      const { scrollWidth, clientWidth } = containerRef.current;
      const updatedValue = scrollWidth > clientWidth;
      if (updatedValue !== isOverflowing) {
        setIsOverflowing(updatedValue);
      }
    }
  };

  useEffect(() => {
    window.addEventListener('resize', updateState);
    return () => window.removeEventListener('resize', updateState);
  }, []);

  handleResize();

  return isOverflowing;
};
